module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('h3', {
    staticClass: "h4 text-center"
  }, [_c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[12][1]"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-2 col-md-8 px-md-5"
  }, [_c('page-form')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cc560c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Logout.vue
// module id = 675
// module chunks = 0